import TreeNode from "primereact/treenode";
import { separator } from "../../WSUtils/keySeparator";
import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface GetTypesResponse extends BackendResponse {
  mapped: Type[];
  item: { [value: string]: string };
}

export interface GetTypesParameters extends NextApiParams {
  group:
    | "aktiviteter"
    | "automail"
    | "avgiftskode"
    | "bransjer"
    | "dager"
    | "deltid"
    | "enhet"
    | "evaluering"
    | "evalueringrekr"
    | "fakturaoppfolging"
    | "funnetgjennom"
    | "gruppesvar"
    | "helligdagsfri"
    | "inntektsmerking"
    | "kandidatstatus"
    | "kjonn"
    | "kontaktfunksjoner"
    | "kunderettigheter"
    | "kundestatus"
    | "kunnskap"
    | "kurs"
    | "lonnsystem"
    | "nasjonalitet"
    | "ordreoppfolging"
    | "overtidsbetingelser"
    | "portaler"
    | "produktgruppe"
    | "regnskapsystem¨"
    | "rekrutteringstatus"
    | "relatertfil"
    | "rettigheter"
    | "sivilstatus"
    | "skattekortperiode"
    | "stilling"
    | "styringskoder"
    | "systemhendelse"
    | "tilbudstatus"
    | "tilgang"
    | "timeberegning"
    | "ukerirotasjon"
    | "utdannelse"
    | "utstyr"
    | "vikaronsker"
    | "vikarrettigheter"
    | "vikarstatus"
    | "vikartype";
  excludeFolderName?: boolean;
  allowTerminated?: boolean;
  styringskode?: number;
}

export const getTypes = withNextApi<GetTypesResponse, GetTypesParameters>(
  "/cvp/CvpGetTypes",
  {
    f: async (args, f) => {
      const result = await f(args);

      let mapped: Type[] = Object.keys(result.item)
        .map((typenr) => {
          let typetext = result.item[typenr];

          return {
            key: typenr + "",
            value: Number(typenr),
            label: typetext.replace("<font>", "").replace("</font>", "").trim(),
            children: null,
          };
        })
        .sort((a, b) => (a.label < b.label ? -1 : 1));

      if (args.excludeFolderName === false) {
        let folders: { [folderName: string]: Type } = {};

        mapped.forEach((item) => {
          const [folderName, ...rest] = (item.label as string).split("\\");

          let folder = folders[folderName];
          if (!folder) {
            folder = {
              key: `GROUP${separator}${folderName}`,
              label: folderName,
              children: [],
            };
            folders[folderName] = folder;
          }

          folder.children.push({
            key: item.value + "",
            value: Number(item.value),
            label: rest.join(""),
            children: null,
          });
        });

        mapped = Object.values(folders).sort((a, b) =>
          a.label < b.label ? -1 : 1
        );
      }

      return { ...result, mapped };
    },
  }
);

export interface Type extends TreeNode {
  key: string;
  value?: number;
  label: string;
  children: Type[];
}
